// extracted by mini-css-extract-plugin
export default {"risk":"styles_risk__VR8EZ","warning":"styles_warning__df8r6"};